import { createSlice } from '@reduxjs/toolkit';
import {
  getAllHolidaysThunk,
  getAllOrdersThunk,
  getClosedOrdersThunk,
  getInActiveOrdersThunk,
} from './DashboardActions';
import { createHolidayObjectByCurrency } from './DashboardHelper';

export interface IHoliday {
  id: number;
  calendarType: string;
  country: string;
  countryShortCode: string;
  holidayDate: string;
  holidayName: string;
  year: number;
}

export interface SwapsDashboardData {
  allOrders: any;
  inActiveOrders: any;
  closedOrders: any;
  loading: boolean;
  inActiveOrdersLoading: boolean;
  closedOrdersLoading: boolean;
  allHolidays: { [key: string]: IHoliday[] };
}

const initialState: SwapsDashboardData = {
  allOrders: {
    openSwaps: [],
    closedSwaps: [],
  },
  inActiveOrders: [],
  closedOrders: [],
  loading: false,
  inActiveOrdersLoading: false,
  closedOrdersLoading: false,
  allHolidays: {},
};

const dashboardSlice = createSlice({
  name: 'Dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllOrdersThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllOrdersThunk.fulfilled, (state, action) => {
        state.loading = false;
        const allOrders = action.payload?.data?.allOrders || { openSwaps: [], closedSwaps: [] };
        state.allOrders = {
          ...allOrders,
          closedSwaps: allOrders.closedSwaps?.map((clsSwap) => {
            return {
              ...clsSwap,
              hideActionBtns: allOrders.openSwaps?.some(
                (opnSwap) =>
                  opnSwap.orderId === clsSwap.orderId &&
                  opnSwap.basketVersion > clsSwap.basketVersion &&
                  !['CANCELLED', 'REJECTED'].includes(opnSwap.status),
              ),
            };
          }),
        };
      })
      .addCase(getAllOrdersThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getInActiveOrdersThunk.pending, (state) => {
        state.inActiveOrdersLoading = true;
      })
      .addCase(getInActiveOrdersThunk.fulfilled, (state, action) => {
        state.inActiveOrdersLoading = false;
        const inactiveOrders = action.payload?.data?.inactiveOrders ?? [];
        state.inActiveOrders = inactiveOrders;
      })
      .addCase(getInActiveOrdersThunk.rejected, (state) => {
        state.inActiveOrdersLoading = false;
        state.inActiveOrders = [];
      })
      .addCase(getClosedOrdersThunk.pending, (state) => {
        state.closedOrdersLoading = true;
      })
      .addCase(getClosedOrdersThunk.fulfilled, (state, action) => {
        state.closedOrdersLoading = false;
        const closedOrders = action.payload?.data?.closedOrders ?? [];
        state.closedOrders = closedOrders;
      })
      .addCase(getClosedOrdersThunk.rejected, (state) => {
        state.closedOrdersLoading = false;
        state.closedOrders = [];
      })
      .addCase(getAllHolidaysThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllHolidaysThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.allHolidays = createHolidayObjectByCurrency(action.payload || []);
      })
      .addCase(getAllHolidaysThunk.rejected, (state) => {
        state.loading = false;
        state.allHolidays = {};
      });
  },
});

// export const {} = swapDashboardSlice.actions;
export default dashboardSlice.reducer;
